import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export const ChainId:{ [key: string]: number } = {
  ETHEREUM: 1,
  BINANCE: 56,
  HARMONY: 1666600000,
  TESTNET: 1666700000,
  LOCAL: 1337
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const FACTORY_ADDRESS:{ [key: number]: string } = {
  1: "",
  56: "",
  1666600000: "0xBdEBd3af1723BBB33A8aDB68e3e77d65D7266F59",
  1666700000: "0xc829d96D7454D06c61c47F9c15090956193f18dF",
  1337: "0x515C48855d0AFCdaA009379ea6ecb861908d1b0b"  //0x316730Ba39D32a44D0CfB7e872D49cC7F5d4d2d5
}


export const INIT_CODE_HASH:{ [key: number]: string } = {
  1: "",
  56: "",
  1666600000: '0xe42f60d0dd775d81070b954b3f4d97f9c2038d52ea6e7b14e2b9d467d1bab05c',
  1666700000: "0x1b293c55c0e14543e968ba2bc9983cf8c7e3f7c661cb4fc01c1047424a6e2234",
  1337: "0x17c02fdb11e993c924cf1935a3bb1c8811d0b28411127186c3fb2d47c9560c99" //v1 0x1b293c55c0e14543e968ba2bc9983cf8c7e3f7c661cb4fc01c1047424a6e2234
}

export const RPC_URLS: { [key: number]: string } = {
  1: "",
  56: "",
  1666600000: 'https://harmony-0-rpc.gateway.pokt.network',
  1666700000: 'https://api.s0.b.hmny.io',
  1337: "http://localhost:7545"
}

  

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
